import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';

@Component({
  selector: 'neoris-modal-performance-monitoring',
   templateUrl: './modal-performance-monitoring.component.html',
  styleUrl: './modal-performance-monitoring.component.css'
})
export class ModalPerformanceMonitoringComponent {
  rowMonitoringData:any={}
  requestPrformanceMonitoring:any=[]=[]
  selectedDataGridMonitoring:any[]=[]


  formMonitoring:UntypedFormGroup = new UntypedFormGroup({})

  constructor(public dialogRef: MatDialogRef<ModalPerformanceMonitoringComponent>,
    private fb: UntypedFormBuilder,
    private controltowerservice:ControltowerService,
    private translate: TranslateService,
    private route: Router,
    private _snackBar:MatSnackBar,
    private propertiesService:PropertiesTowers
  ){
    this.formMonitoring = this.fb.group({
      isvalid: ( ['', []]),
      comment: ( ['', [Validators.required]]),
    
  
    });

  }


  

  get isvalid(){
    return this.formMonitoring.controls
  }

  get comment(){
    return this.formMonitoring.controls
  }



  async save(){
    if(this.formMonitoring.valid){
      //this.rowMonitoringData = JSON.parse(localStorage.getItem("rowMonitoring"))

      this.selectedDataGridMonitoring = JSON.parse(localStorage.getItem('SelectedGridDataMonitoring'))


      console.log("Obteniendo monitoring seleccionado",this.rowMonitoringData)

      console.log('valores del formulario----->',this.rowMonitoringData.value)

      for(let i= 0;i<=this.selectedDataGridMonitoring.length - 1;i++){
        this.requestPrformanceMonitoring.push({SOURCE_DEVICE_ID : this.selectedDataGridMonitoring[i].SOURCE_DEVICE_ID,DATEGROUP: this.selectedDataGridMonitoring[i].DATE,IS_VALID:this.formMonitoring.value.isvalid==""?false:true,EVENT_TYPE_ID:this.selectedDataGridMonitoring[i].EVENT_TYPE_ID,COMMENTS:this.formMonitoring.value.comment})
      }




      /*this.requestPrformanceMonitoring.SOURCE_DEVICE_ID = this.rowMonitoringData.SOURCE_DEVICE_ID
      this.requestPrformanceMonitoring.DATEGROUP = this.rowMonitoringData.DATE
      this.requestPrformanceMonitoring.IS_VALID = this.formMonitoring.value.isvalid
      this.requestPrformanceMonitoring.EVENT_TYPE_ID = this.rowMonitoringData.EVENT_TYPE_ID
      this.requestPrformanceMonitoring.COMMENTS = this.formMonitoring.value.comment
      */

      console.log('datos enviados monitoring save----->',JSON.stringify(this.requestPrformanceMonitoring))
      let success = await this.SavePerformanceMonitoring(this.requestPrformanceMonitoring)

      if(success.statusCode == 200 || success.message == "Success"){
        this.openSnackBar(this.translate.instant('ALERT_SUCCESS'),"OK")
        this.dialogRef.close()
        this.propertiesService.setConfirmRegisterMonitoring(true)
      }
      else{
        this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")
        this.dialogRef.close()
  
      }


    }
    

  }

  close(){
    this.dialogRef.close()
  }


  private async SavePerformanceMonitoring(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.SaveMonitoringPerformance(request).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:',report);
                                  
            resolve(report);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }

}
